<template>
    <div>
        <v-card>                    
            <v-card-title>
                Changes (Unique {{ changes.numberOfUniqueChanges }} / Total {{ changes.numberOfChanges }})
                <v-spacer></v-spacer>
                <v-btn class="primary ma-2" x-small @click="showDetails()" v-if="changes.numberOfChanges > 0" >Details</v-btn>
                <v-btn class="primary ma-2" x-small @click="addChange()" v-if="allowChanges && isAuthorized">Add Change</v-btn>
                <v-btn class="primary ma-2" x-small @click="updateChange()" v-if="allowChanges && isAuthorized">Update Change</v-btn>
            </v-card-title>
            <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                <div class="column">
                    Unique
                </div>
                <div class="column">
                    By host: <span class="col-value">{{ changes.numberOfUniqueChangesHost }}</span>
                </div>  
                <div class="column">
                    By Villa for You: <span class="col-value">{{ changes.numberOfUniqueChangesVfy }}</span>      
                </div>  
                <div class="column">
                    By caretaker: <span class="col-value">{{ changes.numberOfUniqueChangesCaretaker }}</span>
                </div>              
                <div class="column">
                    By Other: <span class="col-value">{{ changes.numberOfUniqueChangesOther }}</span>      
                </div>
            </div>
            <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                <div class="column">
                    Total
                </div>
                <div class="column">
                    By host: <span class="col-value">{{ changes.numberOfChangesHost }}</span>
                </div>  
                <div class="column">
                    By Villa for You: <span class="col-value">{{ changes.numberOfChangesVfy }}</span>      
                </div>  
                <div class="column">
                    By caretaker: <span class="col-value">{{ changes.numberOfChangesCaretaker }}</span>
                </div>              
                <div class="column">
                    By Other: <span class="col-value">{{ changes.numberOfChangesOther }}</span>      
                </div>
            </div>
        </v-card>
        <addUpdHowz ref="addUpdHowz" :huis_encrid="huis_encrid" @updateData="updateData"/>
    </div>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';
    import addUpdHowz from "@/components/huov/howz/addUpdHowz.vue";

    export default {
        props: {
            entity: {
                type: String,
                default: 'all',
                required: false
            },
            encrid: {
                type: String,
                default: '',
                required: false
            },
        },
        components: {
            addUpdHowz,
        },
        mixins: [mxauthorization],
        data() {
            return {
                isAuthorized: false,
                changes: {
                    numberOfChanges: 0,
                    numberOfChangesHost: 0,
                    numberOfChangesCaretaker: 0,
                    numberOfChangesVfy: 0,
                    numberOfChangesOther: 0,
                    numberOfUniqueChanges: 0,
                    numberOfUniqueChangesHost: 0,
                    numberOfUniqueChangesCaretaker: 0,
                    numberOfUniqueChangesVfy: 0,
                    numberOfUniqueChangesOther: 0,
                },
                huis_encrid: (this.entity === 'huis') ? this.encrid : '',
                allowChanges: this.entity === 'huis',  // Changes are allowed only from the onHuis view.
            }
        },
        mounted() {
            this.getAuthorization("acco-changes-update", "isAuthorized");
            this.getHowzCount();
        },
        methods: {             
            getHowzCount(){
                this.$axios.post("ares/json/ares/huov/howz/getHowzCount.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHowzCount"
                    },
                    getHowzCount: {
                        entity: this.entity,
                        encrid: this.encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.resulttext = res.data.error.message;
                    } else {                   
                        this.changes = res.data.getHowzCount;         
                    }
                });   
            },   
            showDetails() {
                let route = this.$router.resolve({ path: "/task/customer_success/howz/howz_overview/" + this.entity + ":" + this.encrid}); 
                window.open(route.href, "_blank");
            },
            updateData(data) {
                // console.log("update data add_upd_howz", data);
                if (data === "refresh") {
                    this.getHowzCount();
                }
            },
            addChange() {
                this.$refs.addUpdHowz.open_dialog("multiple", "", "", "Create new change");
            },  
            updateChange() {
                this.$refs.addUpdHowz.open_dialog("select", "", "", "Update change");
            },  
        }
    }
</script>

<style scoped> 
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.column{
  position: inherit;
  width: 20%;
}
.col-value{
  float:right; 
  font-weight: bold; 
  padding-right: 40px;
}

</style>